module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-cardapio-768x591.c832644f.jpg";